






import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "l-side-menu"
})
export default class LSideMenuComponent extends Vue {}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/layouts/l-side-menu.vue